var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.stamp)?_c('StampEdit',_vm._g(_vm._b({},'StampEdit',{
      company: _vm.company,
      stamp: _vm.stamp,
      isEdit: _vm.isEdit
    },false),{ ok: _vm.ok, cancel: _vm.cancel, updateIcon: _vm.updateIcon })):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }